var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.microviewHostComponentFactory = exports.ErrorUITestId = void 0;
var React = __importStar(require("react"));
var MicroViewLifecyleChannels_1 = require("@tableau/microview-communication-service/lib/src/channelDefinitions/MicroViewLifecyleChannels");
var MicroviewHostService_1 = require("./MicroviewHostService");
var typestyle_1 = require("typestyle");
var Localize_1 = require("../gen-src/Localize");
exports.ErrorUITestId = 'MicroViewHostError';
var errorStyles = typestyle_1.style({
    fontSize: '14px',
    textAlign: 'center',
    lineHeight: '1.5'
});
function microviewHostComponentFactory(microviewMetadata, onMount) {
    return function MicroviewHostComponent(props) {
        var _a = React.useState(false), error = _a[0], setError = _a[1];
        var rootElementRef = React.useRef(null);
        var microviewName = microviewMetadata.name;
        var microviewHostService = MicroviewHostService_1.MicroviewSuperHostService.instance.getHostService(microviewName);
        React.useEffect(function () {
            microviewHostService.bootstrapMicroView();
            if (rootElementRef && rootElementRef.current) {
                if (microviewHostService.bundleReadyPromise === undefined) {
                    return;
                }
                microviewHostService.bundleReadyPromise.then(function () {
                    new MicroViewLifecyleChannels_1.MicroViewRenderChannel(microviewName).call(props);
                }, function () {
                    setError(true);
                });
            }
            return function () {
                new MicroViewLifecyleChannels_1.MicroViewDisposeChannel(microviewName).call();
            };
        }, [rootElementRef, props.locale]);
        React.useEffect(function () {
            var stopListeningToMicroViewFirstTimeRenderChannel;
            microviewHostService.firstTimeRenderCommunicationChannelMessagePromise = new Promise(function (resolve) {
                stopListeningToMicroViewFirstTimeRenderChannel = new MicroViewLifecyleChannels_1.MicroViewFirstTimeRenderChannel(microviewName).listen(function () {
                    resolve();
                });
            });
            return function () {
                if (stopListeningToMicroViewFirstTimeRenderChannel) {
                    stopListeningToMicroViewFirstTimeRenderChannel();
                }
            };
        }, []);
        React.useEffect(function () {
            if (microviewHostService.firstTimeRenderCommunicationChannelMessagePromise === undefined) {
                return;
            }
            microviewHostService.firstTimeRenderCommunicationChannelMessagePromise.then(function () {
                new MicroViewLifecyleChannels_1.MicroViewPropsChangeChannel(microviewName).call(props);
            });
        }, [props]);
        React.useEffect(function () {
            if (onMount) {
                onMount(props);
            }
        });
        return (error ? (React.createElement("div", { id: microviewName, className: errorStyles, "data-tb-test-id": exports.ErrorUITestId },
            React.createElement("strong", null, Localize_1.Messages.searchMicroviewErrorHeader({ MICROVIEW_NAME: microviewMetadata.name })),
            "\u00A0",
            Localize_1.Messages.searchMicroviewErrorMessage())) :
            React.createElement("div", { id: microviewName, ref: rootElementRef }));
    };
}
exports.microviewHostComponentFactory = microviewHostComponentFactory;
//# sourceMappingURL=MicroviewHostComponentFactory.js.map